// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"bracketInfoToolTip_tooltip__hBzKC","bold":"bracketInfoToolTip_bold__MTgdr"};